import { BankAttributes, PaymentMethodsAttributes, PaymentTypeAttributes } from '@albatrosdeveloper/ave-models-package';
import { PaymentConditionTypeEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/payment-condition-type.enum';
import PaymentConditionAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/payment-condition/payment-condition.entity';
import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  SimpleChanges
} from '@angular/core';
import {
  FormGroup,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { getCode } from 'app/utils/method';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@Component({
  selector: 'app-finance-filters',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    NgxMatSelectSearchModule
  ],
  templateUrl: './finance-filters.component.html',
  styleUrl: './finance-filters.component.scss'
})
export class FinanceFiltersComponent {
  getCode = getCode
  @Input() form!: FormGroup;

  @Input() paymentModel: boolean= false;
  @Input() paymentMethodList: PaymentMethodsAttributes[] = [];
  @Input() paymentTypeList: PaymentTypeAttributes[] = [];
  @Input() bankList: BankAttributes[] = [];
  @Input() paymentConditionList: PaymentConditionAttributes[] = [];
  @Input() loadData: boolean = undefined;

  searchPaymentMethod = '';
  searchPaymentType = '';
  searchBank = '';
  searchPayCondition = '';

  filteredPaymentMethodList: PaymentMethodsAttributes[] = [];
  filteredPaymentTypeList: PaymentTypeAttributes[] = [];
  filteredBankList: BankAttributes[] = [];
  filteredPayConditionList: PaymentConditionAttributes[] = [];
  paymentModelList: string [] = Object.values(PaymentConditionTypeEnum)



  ngOnChanges(changes: SimpleChanges): void {
    if (changes['paymentMethodList']) {
      this.filteredPaymentMethodList = [...this.paymentMethodList];
    }
    if (changes['paymentTypeList']) {
      this.filteredPaymentTypeList = [...this.paymentTypeList];
    }
    if (changes['bankList']) {
      this.filteredBankList = [...this.bankList];
    }
    if (changes['paymentConditionList']) {
      this.filteredPayConditionList = [...this.paymentConditionList];
    }
    
    if (changes['loadData'] && changes['loadData'].currentValue === true) {
      // Lógica para cargar los datos de este componente
      // Por ejemplo, fetchDates(), fetchDocuments(), etc.
    }
  }

  filterPaymentMethod(search: string): void {
    const value = search?.toLowerCase() ?? '';
    
     if (value === '') {
      this.filteredPaymentMethodList = this.paymentMethodList;
    } else {
      this.filteredPaymentMethodList = this.paymentMethodList.filter(item =>
        item.name?.toLowerCase().includes(value)
      );
    }
  }

  filterPaymentType(search: string): void {
    const value = search?.toLowerCase() ?? '';

     if (value === '') {
      this.filteredPaymentTypeList = this.paymentTypeList;
    } else {
      this.filteredPaymentTypeList = this.paymentTypeList.filter(item =>
        item.name?.toLowerCase().includes(value)
      );
    }
  }

  filterBank(search: string): void {
    const value = search?.toLowerCase() ?? '';

     if (value === '') {
      this.filteredBankList = this.bankList;
    } else {
      this.filteredBankList = this.bankList.filter(item =>
        item.name?.toLowerCase().includes(value)
      );
    }
  }

  filterPayCondition(search: string): void {
    const value = search?.toLowerCase() ?? '';

     if (value === '') {
      this.filteredPayConditionList = this.paymentConditionList;
    } else {
      this.filteredPayConditionList = this.paymentConditionList.filter(item =>
        item.name?.toLowerCase().includes(value)
      );
    }
  }

  getDisplayValue(list: any[], ids: any, field: string): string {
    if (Array.isArray(ids)) {
      return list
        .filter(item => ids.includes(item._id) || ids.includes(item.code) || ids.includes(item.id))
        .map(item => item?.[field] ?? '')
        .join(', ');
    } else {
      const found = list.find(item => item._id === ids || item.code === ids || item.id === ids);
      return found?.[field] ?? '';
    }
  }

   getTypeLabel(type: string): string {
      const labels = {
        [PaymentConditionTypeEnum.CREDIT]: 'Crédito',
        [PaymentConditionTypeEnum.DEBIT]: 'Contado',
      };
      return labels[type] || type;
    }
}
